// extracted by mini-css-extract-plugin
export default {"shortlistButton":"shortlist_detail_action-modules___shortlistButton___b3481939"};